module.exports = __webpack_public_path__ + "img/Slide26.b0ff04af.png";